export * from "./entity-automation";
